import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'modify-booking-modal',
    ];

    static values = {
        bookingId: Number,
    };

    openModal(event) {
        if (event) {
            event.preventDefault();
        }

        this.modifyBookingModalOutlet.bookingIdValue = this.bookingIdValue;
        this.modifyBookingModalOutlet.showContent();
    }
}
